import { Observable, catchError, of } from 'rxjs';
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TServiceResult } from '@shared/helper/t-service-result';
import { LocalRepository } from '@shared/helper/local-repository';
import { QuoteModel } from '@app/pages/quotes/models/quote-model';
import { PageList } from '@shared/model/categoryAndSearch/pageList-model';
import { HttpBaseService } from '@shared/service/base_services/http_base.service';
import { TermFilterModel } from '@shared/model/categoryAndSearch/term-filter-model';


@Injectable({
  providedIn: 'root'
})
export class QuoteAggrigatorService extends HttpBaseService {

  constructor() {
    const repo = inject(LocalRepository);
    const http = inject(HttpClient);

    super(repo, http, 'v1/quAggr');
  }

  getById(id: string): Observable<TServiceResult<QuoteModel>> {
    return this.http.get<TServiceResult<QuoteModel>>(`${this.apiUrl}/GetById/${id}`);
  }

  getQuotesOnWorkByWorkId(workId: string, termFilter: TermFilterModel): Observable<TServiceResult<PageList<QuoteModel>>> {
    return this.http.get<TServiceResult<PageList<QuoteModel>>>(`${this.apiUrl}/GetQuotesOnWorkByWorkId/${workId}?PgNumber=${termFilter.pgNumber}&PgSize=${termFilter.pgSize}`)
  }

  getLatestWeekQuotes(): Observable<TServiceResult<PageList<QuoteModel>>> {
    return this.http.get<TServiceResult<PageList<QuoteModel>>>(`${this.apiUrl}/GetLatestWeekQuotes`);
  }

  getLatestWeekQuotesWithUserLiked(termFilter: TermFilterModel): Observable<TServiceResult<PageList<QuoteModel>>> {
    const query = this.TermFilterParams(termFilter);
    return this.http.get<TServiceResult<PageList<QuoteModel>>>(`${this.apiUrl}/GetLatestWeekQuotesWithUserLiked?${query}`);
  }

  getChosenQuotes(): Observable<TServiceResult<PageList<QuoteModel>>> {
    return this.http.get<TServiceResult<PageList<QuoteModel>>>(`${this.apiUrl}/GetChosenQuotes`);
  }

  getChosenQuotesWithUserLiked(termFilter: TermFilterModel): Observable<TServiceResult<PageList<QuoteModel>>> {
    const query = this.TermFilterParams(termFilter);
    return this.http.get<TServiceResult<PageList<QuoteModel>>>(`${this.apiUrl}/GetChosenQuotesWithUserLiked?${query}`);
  }

  getGuestQuotes(username: string, termFilter: TermFilterModel): Observable<TServiceResult<PageList<QuoteModel>>> {
    const query = this.TermFilterParams(termFilter);
    return this.http.get<TServiceResult<PageList<QuoteModel>>>(`${this.apiUrl}/GetGuestQuotes/${username}?${query}`)
      .pipe(
        catchError(err => {
          return of(new TServiceResult<PageList<QuoteModel>>(new PageList(), '', null, true, ''))
        })
      )
  }

}